import { Injectable } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { of } from 'rxjs'
import { catchError, map, switchMap } from 'rxjs/operators'
import { LanguagesService } from '../languages.service'
import {
  FetchLanguagesListFailure,
  FetchLanguagesListRequest,
  FetchLanguagesListSuccess,
} from './languages.actions'
import * as languagesTypes from './languages.types'

@Injectable()
export class LanguagesEffectsService {
  constructor(
    private actions: Actions,
    private languagesService: LanguagesService,
  ) {}

  FetchLanguagesList$ = createEffect(() =>
    this.actions.pipe(
      ofType(languagesTypes.FETCH_LANGUAGES_LIST_REQUEST),
      switchMap((action: FetchLanguagesListRequest) => {
        return this.languagesService
          .fetchLanguagesList(action.queryParams)
          .pipe(
            map((result) => {
              return new FetchLanguagesListSuccess(
                result.data.results,
                result.data.totalCount,
                result.data.filteredCount,
              )
            }),
            catchError((err, caught) => {
              return of(new FetchLanguagesListFailure({ error: err }))
            }),
          )
      }),
    ),
  )
}
